"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Range = require("../Range");
var _excluded = ["defaultValue", "onChange"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var WithContainer = function WithContainer(props) {
  var defaultValue = props.defaultValue,
    onChange = props.onChange,
    originalProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)({
      min: defaultValue && defaultValue[_Range.RANGE_VALUE_TYPE.min],
      max: defaultValue && defaultValue[_Range.RANGE_VALUE_TYPE.max]
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    stateValue = _useState2[0],
    setStateValue = _useState2[1];
  var min = stateValue.min,
    max = stateValue.max;
  var parseValue = (0, _react.useCallback)(function (value) {
    if (typeof value !== 'number') {
      return undefined;
    }
    return value;
  }, []);
  var setStateValueByType = (0, _react.useCallback)(function (value, valueType) {
    var updatedValue = _objectSpread({}, stateValue);
    updatedValue[valueType] = parseValue(value);
    setStateValue(updatedValue);
  }, [parseValue, setStateValue, stateValue]);
  var handleChange = (0, _react.useCallback)(function () {
    return onChange && onChange(stateValue);
  }, [onChange, stateValue]);
  var handleInputChange = (0, _react.useCallback)(function (value, valueType) {
    setStateValueByType(value !== '' ? Math.abs(parseFloat(value)) : undefined, valueType);
  }, [setStateValueByType]);
  var handleInputBlur = (0, _react.useCallback)(function (value, valueType) {
    if (value === '') {
      return;
    }
    if (valueType === _Range.RANGE_VALUE_TYPE.min && max !== undefined && parseFloat(value) > parseFloat(max)) {
      setStateValueByType(max, valueType);
    }
    if (valueType === _Range.RANGE_VALUE_TYPE.max && min !== undefined && parseFloat(value) < parseFloat(min)) {
      setStateValueByType(min, valueType);
    }
  }, [max, min, setStateValueByType]);
  var injectedProps = {
    maxValue: max !== undefined ? max : '',
    minValue: min !== undefined ? min : '',
    onChange: handleChange,
    onInputBlur: handleInputBlur,
    onInputChange: handleInputChange
  };
  return /*#__PURE__*/_react["default"].createElement(_Range.Range, (0, _extends2["default"])({}, originalProps, injectedProps));
};
exports.WithContainer = WithContainer;